import { InputProps, MenuItem } from '@mui/material'
import React from 'react'
import { RefCallBack } from 'react-hook-form'
import { InputForm } from './InputForm'

export interface IOptions {
    title: string;
    value?: string | number;
}

interface ISelectOption {
    value?: string
    onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    defaultValue?: string
    label?: string
    placeholder?: string
    name?: string
    style?: React.CSSProperties
    options: IOptions[]
    isFirstNoneDefault?: boolean
    inputProps?: Partial<InputProps>
    inputRef?: RefCallBack
    propsRegister?: object
}

export default function CustomSelect(props: ISelectOption): React.ReactElement {
    return (
        <InputForm
            select
            {...props.propsRegister}
            label={props.label}
            defaultValue={props.defaultValue}
            placeholder={props.placeholder}
            style={props.style}
            InputProps={props.inputProps}
            onChange={props.onChange}
            value={props.value}
            inputRef={props.inputRef}
            size='small'
        >
            {props.isFirstNoneDefault ?
                <MenuItem value='none' disabled>
                    Selecione...
                </MenuItem>
                :
                null
            }
            {props.options.map((option) => {
                return (
                    <MenuItem key={option.title} value={option.value}>
                        {option.title}
                    </MenuItem>
                )
            })}
        </InputForm>
    )
}